import { useSelector } from 'react-redux'
import { openBotIdSelector } from '../../app/selectors'

export function useBotId() {
  return useSelector(openBotIdSelector)!
}
